import React from 'react'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import FAQItems from '../FAQItems'
import { CA_FRAME_FAQ_QUESTIONS, ENGLISH_FAQ_QUESTIONS, USA_FAQ_QUESTIONS } from './constants.js'
import { PLUS_FAQ_QUESTIONS } from '../../templates/PlusProductPage/constants'
import { CAL_FAQ_QUESTIONS } from './cal-constants.js'
import { UNIFIED_FAQ_QUESTIONS } from './unified-constants'

import { Section, ContentContainer } from '../FAQs/styles'
import {
  CAL_PRODUCT_PAGE_FAQ_QUESTIONS,
  INTERNATIONAL_CAL_PRODUCT_PAGE_FAQ_QUESTIONS,
} from '../../templates/FrameProductPage/cal-constants'
import { IS_FOREIGN_COUNTRY, LOCALIZATION } from '../../utils/constants'

const FAQSection = ({ page }) => {
  const { t } = useTranslation('common')

  const calendarProductPageFAQs = !IS_FOREIGN_COUNTRY
    ? CAL_PRODUCT_PAGE_FAQ_QUESTIONS
    : INTERNATIONAL_CAL_PRODUCT_PAGE_FAQ_QUESTIONS
  const QUESTION_OVERRIDES = {
    plus: PLUS_FAQ_QUESTIONS,
    calendar: CAL_FAQ_QUESTIONS,
    calendarProductPage: calendarProductPageFAQs,
    unified: UNIFIED_FAQ_QUESTIONS,
    calMax: calendarProductPageFAQs,
    en: USA_FAQ_QUESTIONS,
    'en-ca': page === 'frame' ? CA_FRAME_FAQ_QUESTIONS : ENGLISH_FAQ_QUESTIONS,
    'en-au': ENGLISH_FAQ_QUESTIONS,
    'en-gb': ENGLISH_FAQ_QUESTIONS,
  }

  const questions = QUESTION_OVERRIDES[page] || QUESTION_OVERRIDES[LOCALIZATION]

  return (
    <ContentContainer page={page}>
      {questions.map((section, j) => (
        <React.Fragment key={j}>
          {section.sectionTitle && (
            <Section>
              <Trans>{section.sectionTitle}</Trans>
            </Section>
          )}
          {section.content.map((content, i) => (
            <FAQItems
              key={i + content.q}
              question={t(content.q)}
              answer={t(content.a)}
              text={t(content.text)}
              link={t(content.link)}
              punctuation={t(content.punctuation)}
              placement={content.placement}
              page={page}
            />
          ))}
        </React.Fragment>
      ))}
    </ContentContainer>
  )
}
FAQSection.propTypes = {
  page: PropTypes.string,
}
export default FAQSection
